import 'reflect-metadata';
import { inject, injectable } from 'inversify';
import { EntityVersioning, Nullable, Team } from '@Models';
import { team_dto } from '@Api';
import { TYPES } from '@Types';
import { ContestMapper } from './ContestMapper';
import { team } from '@Api';
import { IMapper } from '../IMapper';

@injectable()
export class TeamMapper implements IMapper<number, team, team, Team> {
  @inject(TYPES.Mapper.ContestMapper) private _contestMapper!: ContestMapper;

  public map(item: team): Team {
    return {
      id: item.id,
      name: item.name,
      isLeader: item.isLeader,
      contest: this._contestMapper.map(item.contest),
    } satisfies Team as Team;
  }

  public mapFull(item: team): Team {
    return this.map(item);
  }

  mapDto(team: Team): team_dto {
    return {
      name: team.name,
    } satisfies team_dto as team_dto;
  }

  mapVersioning(data: any): Nullable<EntityVersioning<number>> {
    return null;
  }
}
